<template>
  <v-container fluid>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="4" sm="2">
        <p class="small">{{ $t('english_door') }}</p>
      </v-col>
      <v-col cols="8" sm="7">
        <router-link class="x-small-text text-decoration-none grey--text" to="/company/privacy-policy">{{ $t('privacy') }}</router-link> |
        <router-link class="x-small-text text-decoration-none grey--text" to="/company/use-term">{{ $t('terms') }}</router-link>
      </v-col>
      <v-col cols="12" sm="3">
        <a class="btn btn-social">
          <img :src="`${app.cdnUrl}/website/icon/smartstore_logo.png`" width="30"
               @click="openWindow('https://smartstore.naver.com/en9doors' )">
        </a>

          <a class="btn btn-social">
            <img src="@/assets/icon/youtube_icon.svg" width="30"
                 @click="openWindow('https://www.youtube.com/channel/UC_tz6R7pbusavSBdDzCl3kQ' )">
          </a>
          <a class="btn btn-social ">
            <img src="@/assets/icon/instagram_icon.svg" width="30"
                 @click="openWindow('https://www.instagram.com/en9door' )">
          </a>
          <a class="btn btn-social ">
            <img src="@/assets/icon/kakaotalk_icon.svg" width="30"
                 @click="openWindow('https://pf.kakao.com/_gjKqxb/chat' )">
          </a>
      </v-col>
      <v-col cols="12" sm="4">
        <v-row style="text-align: left; font-size: small; color: darkgray;">
          <v-col>
            {{ getSysConfValue('en9door_address') }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>{{ $t('representative') }}</strong> : {{ getSysConfValue('en9door_ceo') }} &nbsp;&nbsp;&nbsp;<br>
            <a v-bind:href="`tel:${getSysConfValue('en9door_tel')}`" >{{ getSysConfValue('en9door_tel') }}</a>
            <br>
            <strong>{{ $t('business_number') }}</strong> : {{ getSysConfValue('en9door_business_no') }}&nbsp;
            <br>
            <strong>{{ $t('online_sales_number') }}</strong> : {{ getSysConfValue('en9door_business_type') }}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <br>
            <a class="text-decoration-underline" @click="copyAccount" >{{ getSysConfValue('en9door_bank') }}</a>
            <br>
            Copyright @English Door All Right Reserved
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4">
        <a href="https://www.digitalocean.com/?refcode=a12269696366&utm_campaign=Referral_Invite&utm_medium=Referral_Program&utm_source=badge">
          <v-img src="https://web-platforms.sfo2.cdn.digitaloceanspaces.com/WWW/Badge%203.svg" alt="DigitalOcean Referral Badge"
                 width="270" />
        </a>
      </v-col>
      <v-col cols="12" sm="4">
        <a @click="openWindow('https://www.payapp.kr/escro_check/2308_7832_494')">
          <v-img :src="`${app.cdnUrl}/website/footer/escrow_mark_290x92.png`"
                 width="270"/>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Footer',
  computed: {
    ...mapGetters(['app','isMobile'])
  },
  methods: {
    openWindow(link) {
      this.$openWindow(link, 'book')
    },
    getSysConfValue(code){
      if (this.app.sysconf.length  === 0) return ''
      return this.app.sysconf.filter(s => s.code === code).map(s => s.value)[0]
    },
    async copyAccount(){
      let bank = this.getSysConfValue('en9door_bank');

      try {
        await navigator.clipboard.writeText(bank)
          .then(() => {
            this.$dialog.notify.info(this.$t('clipboard_copied'), {position: 'top-right', timeout: 1000})
          })
      } catch (err) { console.log(err) }
    }
  },
}
</script>

<style lang="scss">
.small {
  font-size: 0.875rem;
  color: v-bind("$vuetify.theme.dark ? '#e0e0e0' : '#424242'");
}

.x-small-text {
  font-size: 0.75rem;
  &:hover {
    color: v-bind("$vuetify.theme.dark ? '#90caf9' : '#1976d2'") !important;
  }
}

.btn-social {
  opacity: 0.9;
  transition: all 0.3s ease;
  
  &:hover {
    opacity: 1;
    transform: translateY(-2px);
  }
}

.v-divider {
  border-color: v-bind("$vuetify.theme.dark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'") !important;
}

.text-decoration-underline {
  text-decoration: underline;
  cursor: pointer;
  color: v-bind("$vuetify.theme.dark ? '#e0e0e0' : '#424242'");
  
  &:hover {
    color: v-bind("$vuetify.theme.dark ? '#90caf9' : '#1976d2'");
  }
}

.v-container {
  background-color: v-bind("$vuetify.theme.dark ? '#121212' : '#ffffff'");
  color: v-bind("$vuetify.theme.dark ? '#e0e0e0' : '#424242'");
}
</style>
